import React from "react";
// import { AiOutlineCloudDownload } from "react-icons/ai";
import { FaGraduationCap } from "react-icons/fa";

// import CallToAction from "../shared/CallToAction";
import Section from "../shared/section";
// import TechIcons from "../../images/tech-icons.png";
// import Resume from "../../download/Sandesh_Bhujbal_Resume.pdf";

import "./style.scss";

const Skills = () => {
    return (
        <Section
            id="about"
            background="dark"
        >
            <div className="skills-content-wrapper">
                <div className="left-col">
                    {/* <img
                        src={TechIcons}
                        alt="JavaScript, React, CSS, HTML, SASS, Photoshop, Figma"
                    /> */}
                </div>

                <div className="right-col">
                    <h2>ABOUT ME</h2>

                    <p>
                        I am a skilled Software Development Engineer (SDE)
                        driven by a passion for crafting innovative web
                        solutions. Holding a Master's degree in Computer Science
                        from Modern College, Pune (University of Pune) in 2023,
                        I bring a strong foundation and up-to-date knowledge to
                        every project. Known for my adaptability and motivation,
                        I thrive on overcoming challenges and delivering
                        high-quality results. With a continuous commitment to
                        learning and a positive growth mindset.
                    </p>

                    {/* <CallToAction
                        text="Download CV"
                        icon={<AiOutlineCloudDownload />}
                        action={() => window.open(Resume)}
                    /> */}
                </div>
            </div>

            <Section id="education" background="dark">
                <h2 className="section-title">EDUCATION</h2>

                <div className="education-container">
                    <div className="education-card">
                        <div className="education-icon">
                            <FaGraduationCap />
                        </div>

                        <div className="education-details">
                            <div className="education-year">2021 - 2023</div>
                            <div className="education-title">
                                Master's of Computer Science
                            </div>
                            <div className="education-institution">
                                Modern College, Pune | University Of Pune
                            </div>
                        </div>
                    </div>

                    <div className="education-card">
                        <div className="education-icon">
                            <FaGraduationCap />
                        </div>

                        <div className="education-details">
                            <div className="education-year">2018 - 2021</div>
                            <div className="education-title">
                                Bachelor's of Computer Science
                            </div>
                            <div className="education-institution">
                                Waghire College, Saswad | University Of Pune
                            </div>
                        </div>
                    </div>
                </div>
            </Section>

            {/* export default EducationSection; */}
        </Section>
    );
};

export default Skills;